import React from 'react';

function futureTime(seconds: number) {
    return new Date(new Date().getTime() + 1000 * seconds);
}

function formatSeconds(secNum: number) {
    const minutes = Math.floor((secNum) / 60);
    const seconds = secNum - (minutes * 60);

    let minutesStr = minutes.toString();
    let secondsStr = seconds.toString();

    if (Number(minutes) < 10) minutesStr = '0' + minutes;
    if (Number(seconds) < 10) secondsStr = '0' + seconds;
    return minutesStr + ':' + secondsStr;
}

export function useCountdownTimer({
    countdownSeconds = 60
} = {}) {
    const [ , updateTimer ] = React.useState([]);

    const isActiveRef = React.useRef(true);
    const timerRawRef = React.useRef(futureTime(countdownSeconds));
    const seconds = Math.max(0, Math.round((timerRawRef.current.getTime() - new Date().getTime()) / 1000));
    const formatted = formatSeconds(seconds);

    const setTimer = React.useCallback((next = countdownSeconds, isActive = true) => {
        isActiveRef.current = isActive;
        timerRawRef.current = futureTime(next);
        updateTimer([]);
    }, [ countdownSeconds ]);

    React.useEffect(() => {
        const interval = isActiveRef.current ? setInterval(() => updateTimer([]), 1000) : undefined;

        updateTimer([]);

        return () => interval && clearInterval(interval);
    }, [ ]);

    const start = React.useCallback((value?: number) => setTimer(value, true), [ setTimer ]);
    const reset = React.useCallback((value?: number) => setTimer(value, false), [ setTimer ]);

    return {
        start,
        reset,
        seconds,
        formatted
    };
}

